import ApiCore from './api-core'
import { PUBLIC } from '@/constants/api-types'

export default class Reason extends ApiCore {
  constructor(store) {
    super(store, `${PUBLIC}/reason`)
  }

  list(filter, showProgress) {
    return this.request({
      action: 'list',
      params: filter,
      method: 'GET',
      showProgress
    })
  }
}
